import { Box, Button, Center, Flex, Heading, IconButton } from "@chakra-ui/react"
import { keyboards } from "./keyboards"
import ReactMarkdown from 'react-markdown'
import rehypeRaw from "rehype-raw";
import { IoMdArrowBack } from "react-icons/io"
import { BsFillArrowLeftCircleFill } from "react-icons/bs";


import "./index.css"

export const DetailsPane: React.FC<{
  projectId: string
  setCurrentDetailsPane: (projectId: string) => void
}> = ({
  projectId,
  setCurrentDetailsPane
}) => {

    return (
      <Flex direction="column">
        {/* Navbar */}
        <Flex direction="row" bg={`linear-gradient(57deg, rgba(8,12,68,0.65), rgba(8,12,68,0.45)), url(/assets/${keyboards[projectId].imageFile})`} bgSize="cover" bgPosition="center" minH="150px"  >
          <Center minH="100%">
            <Button variant="ghost" pl={12} pr={8} onClick={() => setCurrentDetailsPane("")}>
              <BsFillArrowLeftCircleFill size="64px" color="white" />
            </Button>
          </Center>
          <Center flex={1}>
          <Heading w="100%" textColor="white">{keyboards[projectId].name}</Heading>

          </Center>

        </Flex>
        {/* Contents area */}
        <Box flex={1} m={8}>
          <ReactMarkdown children={keyboards[projectId].description} rehypePlugins={[rehypeRaw]}></ReactMarkdown>

        </Box>
      </Flex >
    )
  }